import type { DepartmentPart } from 'src/contracts/querySelections';

export const getDepartmentsValue = (item: { departments: DepartmentPart[] }) =>
  item.departments.length > 0
    ? item.departments.map((t) => t.type?.Name).join(', ')
    : '-';
